import React from 'react';
import SEO from '../../components/SEO/SEO';
import MainNav from '../../components/MainNav/MainNav';
import Footer from '../../components/Footer/Footer';
import { Link } from 'react-router-dom';
import './NotFoundPage.css';

const NotFoundPage = ({ darkMode, toggleDarkMode }) => {
  return (
    <>
      <SEO 
        title="Página No Encontrada | E-ASY"
        description="La página que buscas no existe. Regresa al inicio o navega por nuestro sitio web."
        keywords="404, página no encontrada, error, e-asy"
        canonical="https://e-asy.es/404"
      />
      <MainNav darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
      <div className={`not-found-page ${darkMode ? 'dark' : 'light'}`}>
        {/* Hero Section */}
        <section className="not-found-hero">
          <div className="not-found-hero-content">
            <div className="not-found-hero-text">
              <h1 className="not-found-hero-title">404</h1>
              <h2 className="not-found-hero-subtitle">Página No Encontrada</h2>
              <p className="not-found-hero-description">
                Lo sentimos, la página que buscas no existe o ha sido movida. 
                Puedes regresar al inicio o explorar nuestras secciones principales.
              </p>
              <div className="not-found-actions">
                <Link to="/" className="not-found-primary-btn">
                  Volver al Inicio
                </Link>
                <Link to="/servicios" className="not-found-secondary-btn">
                  Ver Servicios
                </Link>
              </div>
            </div>
            <div className="not-found-hero-visual">
              <div className="not-found-illustration">
                <div className="error-404">404</div>
                <div className="error-icon">🔍</div>
              </div>
            </div>
          </div>
        </section>

        {/* Quick Navigation */}
        <section className="not-found-navigation">
          <div className="not-found-content">
            <h3 className="navigation-title">¿Qué estás buscando?</h3>
            <div className="navigation-grid">
              <Link to="/servicios" className="navigation-card">
                <div className="card-icon">🛠️</div>
                <h4 className="card-title">Servicios</h4>
                <p className="card-description">Descubre nuestros servicios de desarrollo y consultoría</p>
              </Link>
              
              <Link to="/capacidades" className="navigation-card">
                <div className="card-icon">💡</div>
                <h4 className="card-title">Capacidades</h4>
                <p className="card-description">Conoce nuestras tecnologías y metodologías</p>
              </Link>
              
              <Link to="/sectores" className="navigation-card">
                <div className="card-icon">🏢</div>
                <h4 className="card-title">Sectores</h4>
                <p className="card-description">Explora los sectores en los que trabajamos</p>
              </Link>
              
              <Link to="/sobre-nosotros" className="navigation-card">
                <div className="card-icon">👥</div>
                <h4 className="card-title">Sobre Nosotros</h4>
                <p className="card-description">Conoce nuestro equipo y nuestra historia</p>
              </Link>
              
              <Link to="/contacto" className="navigation-card">
                <div className="card-icon">📞</div>
                <h4 className="card-title">Contacto</h4>
                <p className="card-description">Ponte en contacto con nuestro equipo</p>
              </Link>
              
              <Link to="/tickets" className="navigation-card">
                <div className="card-icon">🎫</div>
                <h4 className="card-title">Soporte</h4>
                <p className="card-description">Obtén ayuda técnica especializada</p>
              </Link>
              
              <Link to="/actualizacion" className="navigation-card">
                <div className="card-icon">📱</div>
                <h4 className="card-title">Descargas</h4>
                <p className="card-description">Descarga nuestras aplicaciones Simply y SwiftLinkERP</p>
              </Link>
            </div>
          </div>
        </section>

        {/* Help Section */}
        <section className="not-found-help">
          <div className="not-found-content">
            <h3 className="help-title">¿Necesitas ayuda?</h3>
            <p className="help-description">
              Si no encuentras lo que buscas, nuestro equipo está aquí para ayudarte.
            </p>
            <div className="help-actions">
              <Link to="/contacto" className="help-btn primary">
                Contactar con Nosotros
              </Link>
              <Link to="/tickets" className="help-btn secondary">
                Crear Ticket de Soporte
              </Link>
            </div>
          </div>
        </section>
      </div>
      <Footer darkMode={darkMode} toggleDarkMode={toggleDarkMode} />
    </>
  );
};

export default NotFoundPage; 